import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'

const discountPropTypes = {
  isActive      : PropTypes.bool.isRequired,
  discountOn    : PropTypes.string.isRequired,
  discountType  : PropTypes.string.isRequired,
  absolute      : PropTypes.number,
  percentage    : PropTypes.number,
  percentageMax : PropTypes.number
}

const DiscountView = ({
  isActive,
  discountOn,
  discountType,
  absolute,
  percentage,
  percentageMax
}) => {

  if (!isActive) return null

  return (
    <>
      {
        discountType === 'absolute' && (
          <div className='d-flex flex-column pr-3 flex-fill'>
            <span className='small text-muted'>{ `${discountOn}` }</span>
            <span className='font-weight-bold'>
              { PriceUtil.formatToIDR(absolute) }
            </span>
          </div>
        )
      }
      {
        discountType === 'percentage' && (
          <div className='d-flex flex-column pr-3 flex-fill'>
            <span className='small text-muted'>{ `${discountOn}` }</span>
            <span className='font-weight-bold'>
              { percentage }{ '%' }
            </span>
            <span className='small'>
              { percentageMax && ` (maks. ${PriceUtil.formatToIDR(percentageMax) })` }
            </span>
          </div>
        )
      }
    </>
  )
}

DiscountView.propTypes = discountPropTypes

export default DiscountView